import * as React from 'react'
import { theme } from '../../theme'

const IconActivityBlue = (props) => (
  <svg
    width={32}
    height={32}
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <defs>
      <path id='activity-blue_svg__a' d='M0 0h27.162v27.163H0z' />
    </defs>
    <g transform='translate(2 2)' fill='none' fillRule='evenodd'>
      <mask id='activity-blue_svg__b' fill='#fff'>
        <use xlinkHref='#activity-blue_svg__a' />
      </mask>
      <path
        d='m23.027 25.795-.832-.832.96-.96a.378.378 0 0 0-.534-.534l-.96.96-.878-.878.96-.96a.378.378 0 0 0-.534-.534l-.96.96-.877-.878.959-.96a.377.377 0 1 0-.534-.534l-.96.96-.878-.88.96-.958a.378.378 0 0 0-.535-.534l-.96.959-.877-.878 1.694-1.694a.378.378 0 0 0-.535-.534l-1.694 1.694-.879-.88.96-.958a.377.377 0 0 0 0-.534.377.377 0 0 0-.534 0l-.96.959-.074-.074 2.769-2.767 8.502 8.502-2.768 2.767zM4.265 24.542l-1.643-1.644.385-1.378 2.635 2.635-1.378.387zm5.22-12.29 1.694-1.694a.377.377 0 0 0 0-.534.377.377 0 0 0-.534 0L8.95 11.718l-.88-.88.96-.958a.378.378 0 0 0-.534-.534l-.958.96-.88-.88.96-.958a.378.378 0 0 0-.534-.534l-.96.959-.878-.878.96-.96a.378.378 0 0 0-.534-.534l-.96.96-.877-.878.959-.96a.378.378 0 0 0-.534-.534l-.96.959-.879-.878 1.695-1.694a.377.377 0 1 0-.534-.534L1.888 4.656l-.52-.521 2.767-2.767 8.502 8.502-2.768 2.767-.384-.385zM21.93 2.179a1.53 1.53 0 0 1 2.163 0l.892.89a1.53 1.53 0 0 1 0 2.163l-.578.578-3.053-3.054.576-.577zm5.067 20.448-8.904-8.902 6.715-6.714.977-.978a2.664 2.664 0 0 0 0-3.764l-.892-.891a2.661 2.661 0 0 0-3.762 0l-7.694 7.69-8.901-8.9a.565.565 0 0 0-.8 0L.167 3.735a.565.565 0 0 0 0 .8l8.902 8.904-6.806 6.803a.576.576 0 0 0-.143.248L.617 25.846a.565.565 0 0 0 .699.699l5.356-1.501a.588.588 0 0 0 .247-.145l6.805-6.805 8.903 8.903a.563.563 0 0 0 .8 0l3.569-3.57a.567.567 0 0 0 0-.8z'
        fill={props.color ?? theme.dark.primary}
        mask='url(#activity-blue_svg__b)'
      />
    </g>
  </svg>
)

export default IconActivityBlue
